import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import CostCenterForm from "components/costCenters/CostCenterForm";
import { createCostCenter } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const CostCenterCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const costCenter = {
    code: "",
    name: "",
    companyID: me.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { name, code, companyID } = valuesParam;

      await API.graphql({
        query: createCostCenter.replaceAll("__typename", ""),
        variables: {
          input: {
            code,
            name,
            companyID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/cost-centers");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <CostCenterForm onSubmit={onSubmit} initialValues={costCenter} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Centro de Costo",
    successAdded: "Centro de Costo agregado con éxito",
    responses: {},
  },
});

export default CostCenterCreateForm;
